import { formatDate } from "@angular/common";
import { LogService } from "../../../../shared/services/log.service";
import { Validator } from "../../../../shared/services/validator";
import { CTRL_NAME_EXTRACTOR } from "../../ctrl.name.extractor";

export class CTRL_416HorsDef implements Validator {

    public static id = 'CTRL_416HorsDef';
    private message = 'error.ctr_416_HorsDef';


    public LOG: LogService = new LogService(CTRL_416HorsDef);

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_416HorsDef.id + '_');


        if (rgs.length > 0) {
            for (var rg of rgs) {
                const ctrl = form.controls[rg];
                const firstChamp = ctrl.value.rgCtrls.firstChamp;
                const firstChampNameWithStepId = map.get(firstChamp);
                const firstChampCtrl = form.controls[firstChampNameWithStepId];

                const toDay = new Date();
                if (this.isNotEmptyOrNullOrUndefined(firstChampCtrl.value) && firstChampCtrl.value <= formatDate(toDay.setDate(toDay.getDate()), 'yyyy-MM-ddTHH:mm', 'en')) {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
            }
        }
    }

    isNotEmptyOrNullOrUndefined(value): boolean {
		return (value !== undefined && value !== null && value !== '' && value !== 'yyyy-MM-dd HH:mm');
	}
}